import { LOCALES } from 'i18n/locales';

const listWorkpackPageIntl = {
    [LOCALES.ENGLISH]: {
        'listWorkpackPage.page.title': 'Downloads',
        'listWorkpackPage.purpose': 'Purpose',
        'listWorkpackPage.status': 'Availability',
        'listWorkpackPage.actions': 'Actions',
        'listWorkpackPage.packAvailable': 'Available',
        'listWorkpackPage.expired': 'Expired',
        'listWorkpackPage.newToday': 'New today',
        'listWorkpackPage.statusCreating': 'Creating',
        'listWorkpackPage.statusFailed': 'Failed',
        'listWorkpackPage.failedTooltipText': 'Creation was unsuccessful. Please try again later or contact NUAR support.',
        'listWorkpackPage.daysLeft': '{days, plural, one {# day left} other {# days left}}',
        'listWorkpackPage.lessThanADayLeft': 'Less than a day left',
        'listWorkpackPage.purpose.prework': 'Pre-work or site investigation',
        'listWorkpackPage.purpose.planned': 'Planned works',
        'listWorkpackPage.purpose.emergency': 'Emergency works',
        'listWorkpackPage.purpose.other': 'Other',
        'listWorkpackPage.viewOnMap': 'View on map',
        'listWorkpackPage.download': 'Download',
        'listWorkpackPage.download.error.title': 'Download failed',
        'listWorkpackPage.download.error.notFound': 'The requested PDF could not be found. Please generate a new PDF and try again.',
        'listWorkpackPage.download.error.expired': 'The download link has expired. Please request a new PDF and try again.',
        'listWorkpackPage.delete': 'Delete',
        'listWorkpackPage.delete.success.title': 'PDF has been deleted',
        'listWorkpackPage.delete.success': '{title} has been deleted'
    },
    [LOCALES.WELSH]: {
        'listWorkpackPage.page.title': '[Downloads]',
        'listWorkpackPage.purpose': '[Purpose]',
        'listWorkpackPage.status': '[Availability]',
        'listWorkpackPage.actions': '[Actions]',
        'listWorkpackPage.packAvailable': '[Available]',
        'listWorkpackPage.expired': '[Expired]',
        'listWorkpackPage.newToday': '[New today]',
        'listWorkpackPage.statusCreating': '[Creating]',
        'listWorkpackPage.statusFailed': '[Failed]',
        'listWorkpackPage.failedTooltipText': '[Creation was unsuccessful. Please try again later or contact NUAR support.]',
        'listWorkpackPage.daysLeft': '[{days, plural, one {# day left} other {# days left}}]',
        'listWorkpackPage.lessThanADayLeft': '[Less than a day left]',
        'listWorkpackPage.purpose.prework': '[Pre-work or site investigation]',
        'listWorkpackPage.purpose.planned': '[Planned works]',
        'listWorkpackPage.purpose.emergency': '[Emergency works]',
        'listWorkpackPage.purpose.other': '[Other]',
        'listWorkpackPage.viewOnMap': '[View on map]',
        'listWorkpackPage.download': '[Download]',
        'listWorkpackPage.download.error.title': '[Download failed]',
        'listWorkpackPage.download.error.notFound': '[The requested PDF could not be found. Please generate a new PDF and try again.]',
        'listWorkpackPage.download.error.expired': '[The download link has expired. Please request a new PDF and try again.]',
        'listWorkpackPage.delete': '[Delete]',
        'listWorkpackPage.delete.success.title': '[PDF has been deleted]',
        'listWorkpackPage.delete.success': '[{title} has been deleted]'
    }
};

export { listWorkpackPageIntl };
